import { Recorder } from './recorder';

const recorder = new Recorder();

export default recorder;
